const supportTypo = {
  label: 'Arquivos de apoio',
  noResults: 'Nenhum resultado encontrado'
};

export default supportTypo;
